import { useFormik } from 'formik'
import useWindowSize from 'hooks/useWindowSize'

import { weekDaysOrder } from 'pages/Bus/helpers/busHelper'

import { busSettingsSchema } from 'pages/Bus/helpers/validationSchema'
import { useEffect, useState } from 'react'

const initialValues = {
  ev_charging: [30, 60],
  electricity_green_percent: 10,
  peak_rate: 30,
  off_peak_rate: 30,
  shoulder_rate: 40,
  price_of_petrol: 0.5,
  price_of_diesel: 0.5,
  operating_period: 8,
  battery_replacement_period: 5,
  diesel_bus_yearly_depreciation: 14,
  electric_bus_yearly_depreciation: 14,
}

const useVehicleSlider = ({ setSettings, selectedVehicleData, regionData }: any) => {
  // const { setSettings, selectedVehicleData, regionData } = useVehicleCalculator()
  const size = useWindowSize()

  const [vehicleData, setVehicleData] = useState({ ...selectedVehicleData })

  const { working_days } = vehicleData

  const sortedWeekDays = weekDaysOrder(working_days)

  const [show_settings, set_show_settings] = useState({
    fuel: true,
    electricity: true,
    general: true,
    vehicle_info: false,
    settings: false,
  })

  const weekFirstCharacters = sortedWeekDays
    .map((item: any) => item.charAt(0))
    .join('')
    .toUpperCase()

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: busSettingsSchema,
    onSubmit: () => {},
  })

  useEffect(() => {
    // @ts-ignore
    formik.setFieldValue('price_of_diesel', regionData?.fuel_diesel_price + 1)
    // @ts-ignore

    formik.setFieldValue('peak_rate', regionData?.electricity_unit_band1_price)
    // @ts-ignore

    formik.setFieldValue('off_peak_rate', regionData?.electricity_unit_band2_price)
    // @ts-ignore

    formik.setFieldValue('shoulder_rate', regionData?.electricity_unit_band3_price)
  }, [regionData]) // eslint-disable-line

  useEffect(() => {
    // @ts-ignore
    formik.setFieldValue('price_of_diesel', regionData?.fuel_diesel_price + 1)
  }, [regionData]) // eslint-disable-line

  useEffect(() => {
    setVehicleData({ ...selectedVehicleData })
  }, [selectedVehicleData])

  useEffect(() => {
    setSettings(formik?.values)
  }, [formik.values, setSettings]) //eslint-disable-line

  useEffect(() => {
    if (formik.values.operating_period < 8) {
      formik.setFieldValue('battery_replacement_period', formik.values.operating_period)
    }
  }, [formik.values.operating_period]) //eslint-disable-line

  useEffect(() => {
    if (size.width !== undefined && size.width <= 960) {
      set_show_settings((prevValues) => ({ ...prevValues, settings: false, vehicle_info: false }))
    }
  }, [size.width !== undefined && size.width <= 960]) //eslint-disable-line

  return {
    formik,
    vehicleData,
    weekFirstCharacters,
    set_show_settings,
    show_settings,
  }
}

export default useVehicleSlider
